/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  $('#root').css('zoom', 'normal')
  if (document.body.clientWidth <= 1080) {
      let scale = document.body.clientWidth / 1080
      $('#root').css('zoom', scale)
  } else {
      const scale = document.body.clientWidth / 1920
      $('#root').css('zoom', scale)
  }

  window.addEventListener(
      'resize',
      (function () {
          var timer
          return function () {
              if (timer) clearTimeout(timer)
              timer = setTimeout(function () {
                  $('#root').css('zoom', 'normal')
                  if (document.body.clientWidth <= 1080) {
                      let scale = document.body.clientWidth / 1080
                      $('#root').css('zoom', scale)
                  } else {
                      const scale = document.body.clientWidth / 1920
                      $('#root').css('zoom', scale)
                  }
              }, 100)
          }
      })()
  )
});

document.addEventListener("DOMContentLoaded", function () {
const cartElements = document.querySelectorAll('.sp-cart');
cartElements.forEach(element => {
  element.addEventListener('click', function() {
    window.location.href = '/cart';
  });
});
// 倒计时
// 生成随机时间
function generateRandomTime() {
  var hours = Math.floor(Math.random() * 15) + 1
  var minutes = Math.floor(Math.random() * 60)
  var seconds = Math.floor(Math.random() * 60)
  //总共的毫秒数
  var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

  return targetTime
}
function TimeDown(value) {
  //倒计时的总秒数
  var totalSeconds = parseInt(value / 1000)
  //取模（余数）
  var modulo = totalSeconds % (60 * 60 * 24)
  //小时数
  var hours = Math.floor(modulo / (60 * 60))
  modulo = modulo % (60 * 60)
  //分钟
  var minutes = Math.floor(modulo / 60)
  //秒
  var seconds = modulo % 60

  hours = hours.toString().length == 1 ? '0' + hours : hours
  minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
  seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

  //输出到页面
  $('.sp_hour').html(hours)
  $('.sp_minute').html(minutes)
  $('.sp_second').html(seconds)
  //延迟一秒执行自己
  if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
  } else {
    setTimeout(function () {
      TimeDown(value - 1000)
    }, 1000)
  }
}
TimeDown(generateRandomTime())


new Swiper(".sp-swiper-fade", {
  // spaceBetween: 10,
  effect: "fade",
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 2000,
  },
  speed: 2000,
});
new Swiper(".sp-swiper-fade2", {
  slidesPerView: 2,
  spaceBetween: 10,
  centeredSlides: true,
  loop: true, //循环滚动
  freeMode: true,
  speed: 6500, //匀速时间
  autoplay: {
    delay: 0,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
});

// 移动端 part9 成分轮播
new Swiper(".sp-part9-swiper", {
  loop: true,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    stopOnLastSlide: false,
  },
  slidesPerView: "auto",
  speed: 5000,
  spaceBetween: 0
});

new Swiper(".sp-swiper-fade1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    slideChange: function (e) {
      e.slides.find(".sp-text").each(function () {
        this.style.animation = "none";
      });
      const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
      if (spText) {
        spText.style.animation = "none";

        spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
      }
    },
  },
  pagination: {
    el: ".sp-pagination",
    clickable: true,
  },
});

new Swiper(".sp-swiper-fade1-ver", {
  direction: "vertical",
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    slideChange: function (e) {
      e.slides.find(".sp-text").each(function () {
        this.style.animation = "none";
      });
      const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
      if (spText) {
        spText.style.animation = "none";

        spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
      }
    },
  },
  pagination: {
    el: ".sp-pagination",
    clickable: true,
  },
});

// PC端三个一组轮播（上下方向）
new Swiper(".sp-swiper-part9-pc", {
  direction: "vertical",
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  loop: true,
  navigation: {
    nextEl: '.sp-swiper-part9-pc .swiper-button-next',
    prevEl: '.sp-swiper-part9-pc .swiper-button-prev',
  },
});

new Swiper(".sp-swiper-scroll1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
});
new Swiper(".sp-swiper-scroll2", {
  slidesPerView: 1.8,
  spaceBetween: 30,
  centeredSlides: true,
  loop: true, //循环滚动
  freeMode: true,
  speed: 5500, //匀速时间
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
});
jQuery(".sp-scroll").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 12,
  vis: 1,
  scroll: 1,
});
jQuery(".sp-scroll2").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 12,
  vis: 1,
  scroll: 1,
});
new Swiper(".sp-swiper1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  spaceBetween: 0,
  loop: true,
  
});
$(".product-box .sp-opt").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  let _index = $(this).index();

  $(this)
    .parents(".product-box")
    .find(".sp-p-img")
    .eq([_index])
    .show()
    .siblings(".sp-p-img")
    .hide();
});

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    if (document.body.clientWidth <= 1060) {
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);
    } else {
      const scale = document.body.clientWidth / 1920;
      $("#root").css("zoom", scale);
    }

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            if (document.body.clientWidth <= 1060) {
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            } else {
              const scale = document.body.clientWidth / 1920;
              $("#root").css("zoom", scale);
            }
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
      config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  lazyLoadImages();



  // 找到所有跳转套餐的锚点链接
  var links = document.querySelectorAll('a[href^="#shopping"]');
  links.forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault(); // 阻止默认的跳转行为
      // 方式一
      const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
      const offsetTop = targetElement.offsetTop;
      let sptop = document.body.clientWidth <= 1080 ? $('.sp-mobile .sp-fixed-top').height() : $('.sp-pc .sp-fixed-top').height();
      window.scroll({
        top:
          offsetTop * $("div#root").css("zoom") -
          sptop * $("div#root").css("zoom"),
        behavior: "smooth", // 使用 smooth 实现平滑滚动
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

let prods = window.product
function getCur(that){
  let product_con = $(that).closest('.product-part');

  let size = product_con.find('.sp-color div.active').attr('data-val')
  return prods.filter(item=>item.option1 == size)[0]
}
function changePrice(that){
  let product_con = $(that).closest('.product-part');
  let num = product_con.find('#calcNumber').val()
  let that1 = that
  let price = (getCur(that1).price * num / 100).toFixed(2)
  let compare = (getCur(that1).compare_at_price * num / 100).toFixed(2)
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  product_con.find('.price1 span').html(price)
  product_con.find('.price2 span').html(compare)
  console.log(product_con.find('.price2 span'))
  let off_font = 100 - Math.ceil(getCur(that1).price / getCur(that1).compare_at_price * 100)
  product_con.find(".price-group .sp-row span").html(off_font);
}

function calcTotal(price, num) {
  let result = Number(price) * Number(num);
  return result.toFixed(2);
}
$(".sp-mobile .reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
  }
  changePrice(this)
});
$(".sp-mobile .add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  changePrice(this)
});

$(".sp-pc .reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
  }
  changePrice(this)
});
$('.sp-cart-pc,.sp-cart-mobile').on('click',function(){
    window.location.href = "/cart"
  })

$(".sp-pc .add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  changePrice(this)
});
$(".sp-pc .product-box").click(function () {
  $(this).addClass("sp-active").siblings().removeClass("sp-active");
});

// 标题文本渐出
const graduallyList = document.getElementsByClassName("gradually");
for (let gradually of graduallyList) {
  const spans = gradually.querySelectorAll("span");
  const paragraph = gradually.querySelector(".sp-sub-title");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 给每个 span 和 i 动画
          spans.forEach((span, index) => {
            span.style.animation = `swift-up-fade 0.5s ease forwards`;
            span.style.animationDelay = `${index * 0.1}s`;

            const i = span.querySelector("i");
            if (i) {
              i.style.animation = `swift-up-fade 0.5s ease forwards`;
              i.style.animationDelay = `${index * 0.1}s`;
            }
          });

          // 段落
          const totalDelay = spans.length * 0.1 + 0.3;
          if (paragraph) {
            paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
            paragraph.style.animationDelay = `${totalDelay}s`;
          }

          observer.unobserve(gradually);
        }
      });
    },
    {
      threshold: 0.3,
    }
  );
  observer.observe(gradually);
}
var imgArr = [
  'https://cdn.shopify.com/s/files/1/0625/6607/2506/files/20251204-pro-1.png',
  'https://cdn.shopify.com/s/files/1/0625/6607/2506/files/2_7cbe0a2a-77d1-4ad5-a7f5-4a604c7be61b.png?v=1766047767',
  'https://cdn.shopify.com/s/files/1/0625/6607/2506/files/20251204-pro-3.png',
  'https://cdn.shopify.com/s/files/1/0625/6607/2506/files/20251204-pro-4.png',
  'https://cdn.shopify.com/s/files/1/0625/6607/2506/files/20251204-pro-5.png',
  'https://cdn.shopify.com/s/files/1/0625/6607/2506/files/20251204-pro-6.png',
]
var imgArrpc = [
  'https://cdn.shopify.com/s/files/1/0625/6607/2506/files/20251204-pro-1.png',
  'https://cdn.shopify.com/s/files/1/0625/6607/2506/files/2_7cbe0a2a-77d1-4ad5-a7f5-4a604c7be61b.png?v=1766047767',
  'https://cdn.shopify.com/s/files/1/0625/6607/2506/files/20251204-pro-3.png',
  'https://cdn.shopify.com/s/files/1/0625/6607/2506/files/20251204-pro-4.png',
  'https://cdn.shopify.com/s/files/1/0625/6607/2506/files/20251204-pro-5.png',
  'https://cdn.shopify.com/s/files/1/0625/6607/2506/files/20251204-pro-6.png',
]
// 产品切换
$('.opt-group .option').click(function () {
  $(this).addClass('active').siblings().removeClass('active')
})
$('#color .option').click(function () {
  var index = $(this).index()
  var index2 = $('#Size .option.active').index()
  changeoption(index, index2)
  changePrice(this)
})
$('#color2 .option').click(function () {
  var index = $(this).index()
  var index2 = $('#Size2 .option.active').index()
  changeoption(index, index2)
  changePrice(this)
})
$('#Size .option').click(function () {
  var index = $('#color .option.active').index()
  var index2 = $(this).index()
  if(index2==0&&index==0){
      $(this).parents(".product-part").find(".top-product img").css("width","")
  }else{
      $(this).parents(".product-part").find(".top-product img").css("width","800px")
      
  }
  changeoption(index, index2)
  changePrice(this)
  
})
$('#Size2 .option').click(function () {
  var index = $('#color2 .option.active').index()
  var index2 = $(this).index()
  if(index2==0&&index==0){
      $(this).parents(".product-part").find(".top-product img").css("width","")
  }else{
      $(this).parents(".product-part").find(".top-product img").css("width","650px")
      
  }
  changeoption(index, index2)
   changePrice(this)
})
function changeoption(index2, index) {


  $('.sp-mobile .top-product>img').attr('src', imgArr[index2])
  $('.sp-pc .top-product>img').attr('src', imgArrpc[index2])
  if(index2){
    $('.sp-pc .top-product>img').css("width",'500px')
    $('.sp-mobile .top-product>img').css("width",'500px')
  }else{
    $('.sp-pc .top-product>img').css("width",'')
    $('.sp-mobile .top-product>img').css("width",'')
  }
//   if (index == 2 && index2 == 1 || index == 0 && index2 == 1 || index == 0 && index2 == 2 || index == 2 && index2 == 2) {
//     $('.sp-pro-only').show()
//   } else {
//     $('.sp-pro-only').hide()
//   }
 

}
function checkDeviceType() {
  const isMobile = window.matchMedia("(max-width: 1080px)").matches;
  return isMobile ? true : false
}
$('.sp-btn-style').click(function(){
  let that = this
  let num = $(this).closest('.product-part').find('#calcNumber').val()
  window.location.href = '/cart/' + getCur(that).id + ':' + num
})

// 加入购物车
addCart()
function addCart() {
  // 加入购物车
  $('.addCerts').click(function () {
    // do something here
  //   var number =
  //     Number($('.sp-cart #cardNum').html()) + Number($('#calcNumber').val())
  //   $('.sp-cart #cardNum').html(number)
  //   if (number > 0) {
  //     $('.sp-cart .num').css('background', '#cf0101')
  //   } else {
  //     $('.sp-cart .num').css('background', '#919191')
  //   }
  const that = this
  var data = {
    id: getCur(that).id,
    quantity: $(this).closest('.product-part').find('#calcNumber').val(),
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    success: function () {
      $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
         $('.sp-cart #cardNum').html(result.item_count)
      });
    },
    dataType: "json",
  });
  const target = $(this).closest(".product-part")
    var img = target.find('.top-product img')
    var flyer = img[0].cloneNode(true)
    flyer.classList.add('clone')
    target.append(flyer)
    $('.clone').css({
      width: img.width(),
      height: img.height(),
      position: 'fixed',
      top: img[0].offsetTop,
      left: img.offset().left,
      'z-index': '99',
    })
    var offset = $('.sp-cart')[0].getBoundingClientRect()
    $('.sp-cart').addClass('shake')
    setTimeout(() => {
      $('.sp-cart').removeClass('shake')
    }, 1000)
    var finish
    if (checkDeviceType()) {
      finish = $('.sp-cart-mobile')[0]
    } else {
      finish = $('.sp-cart-pc')[0]
    }
    $('.clone').animate(
      {
        top: finish.getBoundingClientRect().top,
        left: finish.getBoundingClientRect().left + $('.sp-cart').width() / 2 - 15,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      1000,
      'linear',
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach() // 完成动画后移除克隆的图片
          }
        )
      }
    )
  })
}
// // 点击按钮
// $(".sp-video-btn").click(function () {
//   $(".sp-mask").css("display", "flex");
// });
// // 关闭弹窗按钮

// $(".sp-mask").click(function (e) {
//   if ($(e.target).closest(".sp-mask video").length > 0) {
//   } else {
//     $(".sp-mask").hide();
//   }
// });

// 菜单
$(".sp-menu-btn").click(function (e) {
  $(".sp-menu-mask").show();
});

$(".sp-menu-mask").click(function (e) {
  // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
  // } else {
  $(".sp-menu-mask").hide();
  // }
});

// 滚动隐藏顶部
if (
  $(window).scrollTop() >
  $(".sp-header").height() * $("div#root").css("zoom")
) {
  $(".sp-fixed-top").addClass("sp-fixed");
} else {
  $(".sp-fixed-top").removeClass("sp-fixed");
}

$(window).scroll(function () {
  if (
    $(window).scrollTop() >
    $(".sp-header").height() * $("div#root").css("zoom")
  ) {
    $(".sp-fixed-top").addClass("sp-fixed");
  } else {
    $(".sp-fixed-top").removeClass("sp-fixed");
  }
});

// 问答
$(".q-row").click(function () {
  $(this).parent().toggleClass("sp-show");
});

// 文本渐出动画
const graduallyList2 = document.getElementsByClassName("sp-fade-box");
for (let gradually2 of graduallyList2) {
  const paragraph2 = gradually2.querySelectorAll(".sp-ani");

  const observerAni = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          paragraph2.forEach((span, index) => {
            span.style.animation = `sp-fade-in 1s ease forwards`;
            span.style.animationDelay = `${index * 0.5 + 0.5}s`;
          });

          observerAni.unobserve(gradually2);
        }
      });
    },
    {
      threshold: 0.3,
    }
  );
  observerAni.observe(gradually2);
}
// 文本渐出动画
const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
for (let gradually3 of graduallyList3) {
  const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

  const observerAni = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          paragraph3.forEach((span, index) => {
            span.style.animation = `sp-fade-left 1s ease forwards`;
            span.style.animationDelay = `${index * 0.3 + 1}s`;
          });

          observerAni.unobserve(gradually3);
        }
      });
    },
    {
      threshold: 0.3,
    }
  );
  observerAni.observe(gradually3);
}

// FAQ
// 手风琴交互逻辑 (新增)
$('.sp-qa1-faq-question').on('click', function() {
    var $currentItem = $(this).parent('.sp-qa1-faq-item'); // 当前点击的父级
    var $answer = $(this).next('.sp-qa1-faq-answer'); // 当前的答案部分
    var $icon = $(this).find('.sp-qa1-faq-icon'); // 当前的图标

    // 如果当前已经是打开的，则关闭它
    if ($currentItem.hasClass('active')) {
        $answer.slideUp();
        $currentItem.removeClass('active');
        $icon.removeClass('fa-minus').addClass('fa-plus');
    } else {
        // 如果当前是关闭的：
        
        // 1. 先关闭所有其他的项 (互斥效果)
        $('.sp-qa1-faq-item').removeClass('active');
        $('.sp-qa1-faq-answer').slideUp();
        $('.sp-qa1-faq-icon').removeClass('fa-minus').addClass('fa-plus');

        // 2. 展开当前项
        $currentItem.addClass('active');
        $answer.slideDown();
        $icon.removeClass('fa-plus').addClass('fa-minus');
    }
});
});
